export default __webpack_public_path__ + "static/media/logo3.f4c54bb0.jpeg";